import { render } from "./PasswordExpired.vue?vue&type=template&id=d82b1052"
import script from "./PasswordExpired.vue?vue&type=script&lang=js"
export * from "./PasswordExpired.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__